/**
 * Каталог навыков и группы смежных компетенций для автоподсказок в настройках.
 */

export const SKILL_GROUPS: string[][] = [
  ['JavaScript', 'TypeScript', 'HTML', 'CSS', 'SCSS', 'React', 'Vue', 'Angular', 'Svelte', 'Next.js'],
  ['Node.js', 'Express', 'Django', 'Flask', 'Spring', '.NET', 'Laravel', 'PHP', 'Ruby'],
  ['Python', 'Java', 'C++', 'C#', 'Go', 'Rust', 'Swift', 'Kotlin'],
  ['SQL', 'MySQL', 'PostgreSQL', 'MongoDB', 'Redis', 'GraphQL'],
  ['Figma', 'Adobe Photoshop', 'UI/UX Design'],
  ['Git', 'Docker', 'Kubernetes', 'Linux', 'AWS', 'Azure', 'GCP'],
  ['BPMN', 'Project Management', 'Business Analysis', 'Data Analysis', 'Machine Learning', 'Pandas'],
];

export const ALL_SKILLS: string[] = [...new Set(SKILL_GROUPS.flat())].sort((a, b) =>
  a.localeCompare(b, undefined, { sensitivity: 'base' })
);

function normalize(s: string): string {
  return s.trim().toLowerCase();
}

function findRelatedGroups(query: string): string[][] {
  const q = normalize(query);
  if (!q) return [];
  return SKILL_GROUPS.filter((group) =>
    group.some((skill) => {
      const n = normalize(skill);
      return n.includes(q) || q.includes(n) || n.startsWith(q);
    })
  );
}

/**
 * Подсказки: сначала прямые совпадения по вводу, затем смежные из той же группы.
 */
export function getSkillSuggestions(
  query: string,
  alreadySelected: string[] = [],
  limit = 8
): string[] {
  const q = normalize(query);
  if (q.length < 1) return [];

  const selected = new Set(alreadySelected.map(normalize));
  const out: string[] = [];
  const seen = new Set<string>();

  const push = (skill: string) => {
    const key = normalize(skill);
    if (selected.has(key) || seen.has(key)) return;
    seen.add(key);
    out.push(skill);
  };

  const startsWith: string[] = [];
  const includes: string[] = [];
  for (const skill of ALL_SKILLS) {
    const n = normalize(skill);
    if (selected.has(n)) continue;
    if (n.startsWith(q)) startsWith.push(skill);
    else if (n.includes(q)) includes.push(skill);
  }
  startsWith.forEach(push);
  includes.forEach(push);

  for (const group of findRelatedGroups(query)) {
    for (const skill of group) {
      if (out.length >= limit) break;
      push(skill);
    }
    if (out.length >= limit) break;
  }

  return out.slice(0, limit);
}
